function getMoreReviews() {
  $(".more_reviews, .less_reviews").click(function (e) {
    e.preventDefault()
    var $this = $(this)
    var $container = $('.reviews_wrapper')
    var current_page = $(this).data('page')
    var per_page = $(this).data('per-page')
    $container.addClass('loading-state pink')

    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: ajax_kinougarde_object.ajaxurl,
      data: {
        'action': 'get_more_reviews',
        'page': current_page,
        'per_page': per_page
      },
      success: function (data) {
        data = data.data
        $container.removeClass('loading-state green')
        var new_page_reviews = data.listReviews
        $container.find('.reviews_list').html(new_page_reviews)

        var current_page = parseInt(data.current_page)
        var have_prev_page = data.prev_page
        var have_next_page = data.next_page
        var prev_page = have_prev_page ? current_page - 1 : 1
        var next_page = have_next_page ? current_page + 1 : current_page

        $('.less_reviews').data("page", prev_page)
        $('.more_reviews').data("page", next_page)

        // Set url of current page
        history.replaceState({}, "page " + current_page, $this.attr('href'))

        // Set url of previous and next page
        //$('.less_reviews').attr("href", $('.less_reviews').attr("href").replace(/\/\d\//, '/' + prev_page + '/'))
        //$('.more_reviews').attr("href", $('.more_reviews').attr("href").replace(/\/\d\//, '/' + next_page + '/'))

        /*hide or remove previous page button*/
        if (!have_prev_page) $('.less_reviews').addClass('hidden')
        else $('.less_reviews').removeClass('hidden')

        /*hide or remove next page button*/
        if (!have_next_page) $('.more_reviews').addClass('hidden')
        else $('.more_reviews').removeClass('hidden')

        $('html, body').animate({ scrollTop:$container.offset().top - $('header').height() }, 'slow')
      },
      error: function (data) { /* console.log('error') */ }
    })
  })
}

getMoreReviews()